module.exports = {
    message:{
        helpCenter:"帮助中心",
        wallet:"钱包",
        account:"账号",
        csaf:"积分",
        backupAndRestore:"备份与恢复",
        committee:"理事会",
        witness:"见证人",
        authorizedRegistrars:"授权注册商",
        vote:"投票",
        collateral:"抵押",
        gateway:"网关",
        extraFunctions:"额外功能",

        wallet_info:[
            {
                title:"关于YOYOW钱包",
                desc:[
                    "YOYOW 是基于区块链技术的媒体公链。本钱包是用来储存、转账YOYO的客户端，通过一个受信任的节点连接，在这里可以方便管理您的YOYO资产。"
                ]
            },
            {
                title:"钱包安全性",
                desc:[
                    "请务必备份好您的私钥，账号私钥拥有最高权限，可用于账号找回和密码重置，账号私钥丢失后无法找回，请务必仔细保管。"
                ]
            },
            {
                title:"账号恢复",
                desc:[
                    "某些特殊情况下导致您app本地数据丢失，可通过账号私钥来重置账号。"
                ]
            },
            {
                title:"YOYOW主账户",
                desc:[
                    "①主账户可以看做是您账号的主力钱包。对主账户进行转账、支付手续费等操作，需要有资金权限(active)。 ",
                    "②主账户中的YOYO可以积累积分。",
                    "③建议将大额YOYO在主账户中存储。"
                ]
            },
            {
                title:"YOYOW零钱",
                desc:[
                    "①零钱可以看做是您账号的辅助钱包，进行小额的存储与转账。操作零钱，需要有发帖权限(secondery)。 ",
                    "②零钱中的YOYO不可积累积分。",
                    "③由于发帖权限可能被赋予第三方媒体平台，建议零钱中只存储小额YOYO。"
                ]
            },
        ],

        account_info:[
            {
                title:"账号",
                desc:[
                    "您需要注册一个YOYOW账号来接入本系统，输入账号密码，系统会为您自动分配一个YOYOW账号。 每个账号的基本信息包括：数字UID(yoyo号)，账户名(昵称)。"
                ]
            },
            {
                title:"账号注册",
                desc:[
                    "①只有授权注册商才可以注册新账户。",
                    "②授权注册商名单由理事会指定。"
                ]
            },
            {
                title:"账号权限",
                desc:[
                    "①账户授权分为三个级别：主控权限(owner)、资金权限(active)、发帖权限(secondary)。",
                    "②主控权限：用于修改其他权限。",
                    "③资金权限：可修改发帖权限；可进行主账户转账。",
                    "④发帖权限：可用于媒体平台各操作(如发帖、回帖、点赞)，可进行零钱转账。",
                    "⑤各级权限只能做权限内的事情，不能向上或向下越权。 ",
                ]
            }
        ],

        csaf_info:[
            {
                title:"积分",
                desc:[
                    "积分是对YOYO持有者的奖励，当您的账号持有YOYO时，积分可随时间累积。积分积累有上限，您需要手动领取积分。"
                ]
            },
            {
                title:"积分用途",
                desc:[
                    "积分目前唯一用途是抵扣手续费。在支付手续费时，您可以选择通过积分进行抵扣。100积分等价值于1YOYO。"
                ]
            },
            {
                title:"积分获取",
                desc:[
                    "①当您账户“主账户”部分拥有一定数量的YOYO时，系统会自动为您积累积分。最高积累量 = 积分积累速率*7。",
                    "②积分积累速率： 当前设定每10000 YOYO 每天可领取 1 YOYO的等价值积分。 ",
                    "③积分需要手动领取，可手动将待领取积分领取至您的账户。"
                ]
            },
            {
                title:"积分租借",
                desc:[
                    "后续会开通积分租借功能。"
                ]
            },
            {
                title:"积分赠与",
                desc:[
                    "目前，可在“领取积分”操作时，选择已有的联系人账号，即可将积分领取至其账号。"
                ]
            },
        ],

        backupAndRestore_info:[
            {
                title:"私钥备份",
                desc:[
                    "当您注册成功时，系统会返回给一个账号私钥。该私钥为拥有您账号权限中的主控权限(owner)，账号私钥拥有最高权限，可用于账号找回和密码重置，账号私钥丢失后无法找回，请务必仔细保管。"
                ]
            },
            {
                title:"私钥恢复账号",
                desc:[
                    "本方法原理为：使用主控权限的私钥，重新生成其他权限的密钥对。",
                    "本方法需要您输入新的钱包密码，并用其对新的密钥对进行加密存储。",
                    "所需参数： 账号owner权限的私钥，新的账号密码。",
                    "本操作需要上链，需支付一定的手续费。"
                ]
            },
        ],
        committee_info:[
            {
                title:"理事会",
                desc:[
                    "理事会由一组股东投票通过的理事会成员组成，理事会成员的职责在于设定系统运行参数。"
                ]
            },
            {
                title:"理事会职责",
                desc:[
                    "调节系统运行各项参数，包括手续费费率、出块奖励等",
                    "与BTS理事会的设计不同，yoyow 里的理事会更像是一个执行机构，拥有部分决策权"
                ]
            },
            {
                title:"理事会设定",
                desc:[
                    "理事会成员数初始设定为5人，不可修改",
                    "每届理事会成员任期1个月，不可修改",
                    "初始理事会成员名单由系统指定，后续理事会由持币人投票选举产生",
                    "暂无报酬机制"
                ]
            },
            {
                title:"候选理事",
                desc:[
                    "任何账户抵押一定数量的YOYO ，即可成为候选理事身份。初始设置1000 YOYO",
                    "只有候选理事，方有资格被投票成为正式理事"
                ]
            },
            {
                title:"理事会选举",
                desc:[
                    "持币人一票一投：即每个账号同时只可支持一位候选人，持票人可随时修改投票",
                    "其他规则如投票资格、投票意向、有效票数、投票有效期、代理等，与见证人投票共用，参考见证人设计之“持币人投票”",
                    "换届时间点，得票最高的 5 个候选理事，成为新的在任理事。暂不设置最低票数"
                ]
            },
            {
                title:"理事会提案",
                desc:[
                    "在任理事会成员可以发起提案，由理事会全体成员表决",
                    "每个提案包括如下属性：提案内容，表决截止时间，表决通过阈值，提案生效时间",
                    "通过阈值根据提案类型预设，不可指定。暂时只设通过阈值，不设否决阈值",
                    "一个提案可包含多项内容，此情况下，必须全部通过或者全部不通过，通过阈值采用多项内容中最高阈值",
                    "提案生效时间不得晚于任期结束时间。生效时间可设为过去的时间，效果为“即时生效”",
                    "理事会表决拥有三种状态： 赞成、中立、反对；提案发起人默认赞成；所有理事会成员每人一票，生效前均可改票",
                    "赞成人数达到阈值时，如果生效时间已过，则提案即时生效，否则提案将按计划在生效时间生效",
                    "表决截止时间前，且提案生效前，表决人可以修改意见；表决截止时间后，不可修改意见",
                    "理事会提案需在任期内表决完成，没表决完成的提案，任期结束时自动作废；表决完成通过的提案，按计划生效，任期结束不影响提案效力",
                    "提案生效并不等于修改的系统参数马上发挥作用，因为不同系统参数预设有不同启用条件/方式"
                ]
            },
            {
                title:"理事引退",
                desc:[
                    "候选理事/正式理事 均可终止理事身份，系统会延迟返还押金",
                    "正式理事选择引退后，并不影响本任期内身份，但下个任期不再有被投票资格",
                    "引退后，所有得票清零（换届时生效）",
                    "若在延迟释放期间重新申请理事身份，尚未释放的币将重新锁定，但已清零的票将无法恢复"
                ]
            },
        ],
        witness_info:[
            {
                title:"见证人",
                desc:[
                    "见证人由一组股东投票通过的成员组成，见证人负责出块维护YOYOW链运行，同时获得相应的奖励。"
                ]
            },
            {
                title:"见证人类型",
                desc:[
                    "主力见证人：由持币人直接投票产生，按得票数排名",
                    "备选见证人：按票数排名，除去主力见证人之外，按照得票数量加权，轮流上岗",
                    "矿工见证人：按抵押排名产生，按抵押金额加权，轮流上岗"
                ]
            },
            {
                title:"见证人资格（抵押）",
                desc:[
                    "任意账户抵押一定数量的YOYO ，即可成为见证人。抵押最小值，当前值10000YOYO",
                    "见证人可随时调整抵押金额",
                    "降低抵押金额或者解除抵押时，押金延迟一段时间后退还，当前值1天",
                    "连续多次降低抵押时，金额累加一起退还，计划退还时间以最后一次降低时间为准进行延迟",
                    "增加抵押时，如果当前账号有延迟退还的押金，优先从里面扣，不足部分从余额扣取"
                ]
            },
            {
                title:"见证人工资",
                desc:[
                    "每出一块，出块见证人获得相应工资/奖励，不设锁定期",
                    "见证人随时可以将“待领取”工资领取到余额中",
                    "不同类型见证人有不同金额的工资奖励"
                ]
            },
            {
                title:"见证人选举",
                desc:[
                    "主力见证人 与 备选见证人，通过得票排名计算。投票规则详见投票",
                    "矿工见证人，通过抵押排名计算。抵押排名规则详见抵押"
                ]
            },
        ],
        authorizedRegistrars_info:[
            {
                title:"授权注册商",
                desc:[
                    "授权注册商由理事会指定，拥有注册账号的权限。"
                ]
            },
            {
                title:"注册商权利",
                desc:[
                    "通过水龙头向链上提交账号注册请求",
                    "赋予/收回发帖权",
                    "审批/收回账户名（昵称）",
                    "更多注册商权利细则，等待后续开发完成"
                ]
            },
            {
                title:"注册商义务",
                desc:[
                    "审核用户提交的改名申请"
                ]
            },
            {
                title:"注册商变更",
                desc:[
                    "当某注册商被理事会取消授权后，该注册商旗下所有账户需要被接管。相应权利与义务会被转移"
                ]
            },
        ],
        vote_info:[
            {
                title:"投票",
                desc:[
                    "YOYOW采用DPOS共识算法，根据这种算法，全网持有代币的人可以通过投票系统来选择见证人、理事会，从而实现对YOYOW系统的决策。"
                ]
            },
            {
                title:"投票资格",
                desc:[
                    "持币数量达到一定数量 N 后，即获得投票资格。持币数量低于该数量 N ，自动失去投票资格。当前值 N = 10000，理事会可修改",
                    "被理事会设置黑名单的账户，丧失投票资格"
                ]
            },
            {
                title:"投票意向",
                desc:[
                    "拥有投票资格的用户，初次进行投票操作时激活投票意向。有效期为T ,初始默认90天",
                    "在有效期内，如有新的投票操作，则有效期递延时间T。即过期时间变更为：更新投票操作时间+T",
                    "在有效期内，如无新的投票操作，则认为不再有投票意向",
                    "用户失去投票资格， 或不再有投票意向，则选票失效"
                ]
            },
            {
                title:"投票方式",
                desc:[
                    "理事会选举：一票一投，每个账号同时只可支持一位候选人，持票人可随时修改投票",
                    "见证人选举：一票多投，为了强化共识，每个账户可以给多个见证人投票"
                ]
            },
            {
                title:"计票",
                desc:[
                    "为增加投票公平性，计票综合考虑了投票者当前持币量、平均持币量、持币时间等因素",
                    "投票人的有效票数等于60天内平均余额，与账号当前余额的较小值，即：有效票数 = min(60天平均余额，当前余额)",
                    "被投票人的得票数，等于所有支持者有效票数之和",
                    "因为实时更新所有账户币龄计算量太大，故计票采用延迟更新模式，可能与实时数据有少量计票误差"
                ]
            },
            {
                title:"投票代理",
                desc:[
                    "投票可设置代理人，如：账户A设置账户B为投票代理，则B的投票对象得到的票数为A的有效票数 + B的有效票数。 A 称之为委托人，B 称之为代理人",
                    "可设置多层代理。如：账户A 设置账户B为投票代理，账户B设置了账户C为投票代理。但代理总层数有上限",
                    "不可代理自己",
                    "代理人进行投票操作时，会刷新委托人的投票意向有效期",
                    "如果代理人失去投票意向或者投票资格，代理关系自动解除，委托人投票状态变为“不投票给任何人”，委托人投票意向有效期不变",
                    "代理人重新激活投票意向时，代理关系不恢复"
                ]
            },
        ],
        collateral_info:[
            {
                title:"抵押",
                desc:[
                    "每期矿工见证人的名额，根据各见证人抵押率进行选择。"
                ]
            },
            {
                title:"抵押排名规则",
                desc:[
                    "基本思路为根据各账号有效抵押安排排名。如：只有ABC三人抵押，其中A有效抵押6个币，B有效抵押3个币，C有效抵押1个币，那么在后续100个块中，应该安排A出块60个，B出块30个，C出块10个",
                    '有效抵押为"7天内平均抵押"与"当前抵押"两者较小值，即：增加抵押时，有效抵押数缓慢增加；降低或解除抵押时，有效抵押立即减少'
                ]
            },
        ],
        gateway_info:[
            {
                title:"网关",
                desc:[
                    "目前只开通 ERC20代币转入YOYOW主链的单向操作。若您持有YOYOW的 ERC20代币，可通过该功能将代币转入YOYOW主链。"
                ]
            },
            {
                title:"操作",
                desc:[
                    '点击"ERC20代币网关"，若您未有绑定的ETH账号，可点击"生成地址"获得一个独有的ETH地址。',
                    "将您的YOYOW ERC20代币，转入该地址中，系统会自动将等量YOYO转入您对应的YOYOW账号下。",
                    '可在"近期活动"或"资产"中查阅入账情况。'
                ]
            },
        ],
        extraFunctions_info:[
            {
                title:"平台授权",
                desc:[
                    "授权内容平台后，即可以使用授权的YOYOW账号登录该平台，同时平台将拥有您的零钱权限。您可以使用一个YOYOW账号授权多个平台。可以在app上便捷地给平台投票。"
                ]
            },
            {
                title:"信息售卖",
                desc:[
                    "用户可以通过使用“信息售卖”进行信息的售卖和购买，实现区块链的信息售卖功能，目前仅接受YOYO付费。"
                ]
            },
            {
                title:"Token发行",
                desc:[
                    "可以实现自己发行和管理Token，只需缴纳一部分手续费即可，手续费的费用根据Token名称的长度收费，长度越短费用越高，长度越长费用越低。"
                ]
            },
            {
                title:"联系我们",
                desc:[
                    "如有其他任何问题，可以咨询：",
                    "YOYOW客服微信号：<a>yoyow99</a>",
                    "YOYOW官网：<a>https://www.yoyow.org</a>",
                    "YOYOW邮箱：<a>help@yoyow.org</a>",
                ]
            },
        ],

        service_protocol_name:"《YOYOW服务协议》",
        version_log:"版本日志",
    }
}


// WEBPACK FOOTER //
// ./src/assets/common/zh.js